import { createActionGroup } from '@ngrx/store';

export const ChapterActions = createActionGroup({
  source: 'Chapter',
  events: {},
});
